<template>
  <div class="sidebar-collapse">
    <div
      v-for="(group, group_en, groupIndex) in groupedNavItems"
      :key="group_en"
      :style="{ display: 'flex', flexDirection: 'column' }"
    >
      <v-list-tile
        :name="item.name_vn"
        :color="item.active ? item.color : ''"
        v-for="(item, index) in group"
        :class="
          darkTheme
            ? item.active
              ? 'item-menu__mini-content-dark-not-hover'
              : 'item-menu__mini-content-dark'
            : 'item-menu__mini-content-light'
        "
        :key="index"
        @click.prevent="changeNavicationRouteItem($event, item)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-tile-action v-on="on" style="padding: 12px">
              <v-icon
                :class="item.active ? 'item-menu__mini-active' : 'item-menu__mini'"
                :color="item.active ? item.color : ''"
                :style="{ backgroundColor: `${item.active} : #e6e9ec : ''` }"
              >
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
          </template>
          <span class="tooltip-container">
            {{
              localeSuffix === '_vi_vn' ? item.name_vn || item.name : item.name_en || item.name
            }}</span
          >
        </v-tooltip>
      </v-list-tile>
      <div
        v-if="groupIndex < Object.keys(groupedNavItems).length - 1"
        :style="{
          borderBottom: `1px solid ${darkTheme ? 'rgba(255, 255, 255, 0.18)' : '#e6e9ec'} `,
          paddingTop: '16px',
          margin: '0px 16px'
        }"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarV2Collapse',
  props: {
    groupedNavItems: {
      type: Array
    },
    onChangeRoute: {
      type: Function
    }
  },
  methods: {
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    },
    ...mapGetters(['localeSuffix'])
  }
}
</script>
<style lang="scss" scoped>
.sidebar-collapse {
  height: inherit;
  overflow-y: auto;
  padding-bottom: 32px;

  &::-webkit-scrollbar {
    width: 0;
  }
}

.item-menu__mini-content-dark {
  a {
    padding: 0 !important;

    &:hover {
      background-color: transparent !important;
    }

    .v-list__tile__action {
      i {
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }

        &:active {
          background-color: #e6e9ec;
          color: #096dd9;
        }
      }
    }
  }

  .item-menu__mini-active {
    border-radius: 8px;
    padding: 12px;
    background-color: #e6e9ec;
    color: #096dd9;

    &:hover {
      background-color: #e6e9ec;
      color: #096dd9;
    }
  }

  .item-menu__mini {
    padding: 12px;
    border-radius: 8px;
  }
}

.item-menu__mini-content-dark-not-hover {
  a {
    padding: 0 !important;

    &:hover {
      background-color: transparent !important;
    }

    .v-list__tile__action {
      i {
        &:hover {
          background-color: #e6e9ec;
        }

        &:active {
          background-color: #e6e9ec;
          color: #096dd9;
        }
      }
    }
  }

  .item-menu__mini-active {
    border-radius: 8px;
    padding: 12px;
    background-color: #e6e9ec;
    color: #096dd9;

    &:hover {
      background-color: #e6e9ec;
      color: #096dd9;
    }
  }

  .item-menu__mini {
    padding: 12px;
    border-radius: 8px;
  }
}

.item-menu__mini-content-light {
  a {
    padding: 0 !important;

    &:hover {
      background-color: transparent !important;
    }

    .v-list__tile__action {
      i {
        &:hover {
          background: #e6e9ec;
        }

        &:active {
          background-color: #e6e9ec;
          color: #096dd9;
        }
      }
    }
  }

  .item-menu__mini-active {
    border-radius: 8px;
    padding: 12px;
    background-color: #e6e9ec;
    color: #096dd9;
  }

  .item-menu__mini {
    padding: 12px;
    border-radius: 8px;
  }
}

.tooltip-container {
  padding: 8px;
  height: fit-content;
  border-radius: 8px;

  .tooltip_content {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    padding: 0 !important;
  }
}

.v-tooltip__content {
  margin-left: -8px !important;
}
</style>
<style lang="scss">
.v-tooltip__content {
  color: #000;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  line-height: 16px;
  border: 1px solid var(--neutral-00, #fff);
  background: rgba(252, 252, 252, 0.9);
  box-shadow: 0 24px 40px -11px rgba(0, 0, 0, 0.1), 0 -13px 24px -7px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(12px);
}

.v-tooltip__content::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -8px;
  transform: translateY(-50%) rotate(180deg);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 8px; /* Điều chỉnh kích thước mũi tên */
  border-color: transparent transparent transparent #fff; /* Màu mũi tên */
}
</style>
